// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__2MvfG","footer":"ChangeClinic_footer__lxKpf"};